/* German translation for the jQuery Timepicker Addon */
/* Written by Marvin */
export default (function ($) {
  $.mctimepicker = $.mctimepicker || {};
  $.mctimepicker.regional.de = {
    timeOnlyTitle: 'Zeit W&auml;hlen',
    timeText: 'Zeit',
    hourText: 'Stunde',
    minuteText: 'Minute',
    secondText: 'Sekunde',
    currentText: 'Jetzt',
    closeText: 'Fertig',
    saveText: 'Speichern',
  };
  $.mctimepicker.setDefaults($.mctimepicker.regional.de);
}(jQuery));
